<template>
  <v-container class="fullWidthBanner color1">
    <v-row>
      <div class="text-center" style="margin: auto;">
        <h1 class="display-1">{{ tl(getExploreBannerData.title) }}</h1>
      </div>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" md="4" v-for="(content, idx) in getExploreBannerData.content" :key="idx">
        <v-container>
          <v-row>
            <v-img :src="content.image" max-height="100" contain transition="fab-transition"></v-img>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <h2>{{ tl(content.title) }}</h2>
                <br />
                <p>{{ tl(content.description) }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-btn
                  tile
                  class="color3 background--text"
                  @click="exploreBtnClick(content.button.link)"
                >{{ tl(content.button.text) }}</v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Explore",
  data() {
      return {
          dialog: {
              contact: false
          }
      }
  },
  computed: {
    ...mapGetters(["getExploreBannerData"])
  },
  methods: {
    exploreBtnClick(routerLink) {
      this.logEvent("button_clicked", {
        name: "exploreButton",
        link: routerLink
      });

      var params = {
        lang: this.$i18n.locale
      }
      if (this.$route.name !== routerLink) {
        if (routerLink == "myWork") {
          params.type = "thesis";
        }

        this.gotoRoute(routerLink, params);
      }
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.4em;
}
</style>